import type { BaseSelection } from "lexical";
import { $getRoot, $getSelection } from "lexical";

/**
 * The moment editors mount with autofocus off, fall back to a caret at the start of the message
 * rather than silently doing nothing.
 *
 * Must be called from inside an editor update (e.g. a command handler).
 */
export const $selectionOrStart = (): BaseSelection => $getSelection() ?? $getRoot().selectStart();
